"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelixBanUser = void 0;
const tslib_1 = require("tslib");
const shared_utils_1 = require("@d-fischer/shared-utils");
const common_1 = require("@twurple/common");
/**
 * Information about a user who has been banned/timed out.
 */
let HelixBanUser = class HelixBanUser extends common_1.DataObject {
    /**
     * The ID of the broadcaster whose chat room the user was banned/timed out from chatting in.
     */
    get broadcasterId() {
        return this[common_1.rawDataSymbol].broadcaster_id;
    }
    /**
     * The date and time that the timeout was created.
     */
    get creationDate() {
        return new Date(this[common_1.rawDataSymbol].created_at);
    }
    /**
     * The date and time that the timeout will end. Is `null` if the user was banned instead of put in a timeout.
     */
    get endDate() {
        return (0, shared_utils_1.mapNullable)(this[common_1.rawDataSymbol].end_time, ts => new Date(ts));
    }
    /**
     * The ID of the moderator that banned or put the user in the timeout.
     */
    get moderatorId() {
        return this[common_1.rawDataSymbol].moderator_id;
    }
    /**
     * The ID of the user that was banned or was put in a timeout.
     */
    get userId() {
        return this[common_1.rawDataSymbol].user_id;
    }
};
HelixBanUser = tslib_1.__decorate([
    (0, common_1.rtfm)('api', 'HelixBanUser', 'userId')
], HelixBanUser);
exports.HelixBanUser = HelixBanUser;
